import { lazy } from 'react';

import LazyWithRetry from '../../components/shared/LazyWithRetry';
import LazyWithSuspense from '../../components/shared/LazyWithSuspense';

const CreateCustomerLazy = LazyWithSuspense(
    lazy(
        () =>
            LazyWithRetry(
                () => import('./CreateCustomer'),
                'CreateCustomer',
            ) as any,
    ),
);

export default CreateCustomerLazy;
